module.exports = "<div class=\"map-core\" id=\"map-core\"></div>\n\n<div id=\"popup\" class=\"ol-popup\">\n\t<a href=\"#\" id=\"popup-closer\" class=\"ol-popup-closer\" ng-click=\"closePopup();\"></a>\n\t<div id=\"popup-content\"></div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./scripts/apps/dashboard/directives/views/map.html
// module id = 557
// module chunks = 0